import OfferCard from "./OutcomeDiaryCard";

export default OfferCard;
